

<p-confirmDialog />

<div class="plan-page-container">
  <div class="plan-page-header">
    <h3 class="m-0">Milestone Plan</h3>
    <p-button
      label="Add"
      icon="pi pi-plus"
      (onClick)="showAddTaskDialog()"
      severity="info"
      [rounded]="true" />
  </div>

  <p-table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="tasks"
    [loading]="loading"
    [paginator]="tasks.length > 10"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 20, 50]"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="p-datatable no-column-lines compact-striped-table table-scroll-both milestone-plan-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 100px; text-align: center;">
          #
        </th>
        <th>Task</th>
        <th>Deliverable</th>
        <th class="col-status">Start Date</th>
        <th class="col-status">Target Date</th>
        <th class="col-status">Actual Date</th>
        <th class="col-status">Status</th>
        <th>Comments</th>
        <th class="th-actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-task>
      <tr>
        <td style="text-align: center;">
            {{ task.taskNumber }}
        </td>
        <td>{{ task.task }}</td>
        <td>{{ task.deliverable || '-' }}</td>
        <td>{{ formatTaskDate(task.startDate) }}</td>
        <td>{{ formatTaskDate(task.targetDate) }}</td>
        <td>{{ formatTaskDate(task.actualDate) }}</td>
        <td>
          <p-tag
            [value]="getDisplayStatus(task.status)"
            [severity]="getTaskStatusSeverity(task.status)" />
        </td>
        <td class="td-truncate" [pTooltip]="task.comments || '-'" tooltipPosition="top">{{ task.comments || '-' }}</td>
        <td class="table-cell-actions">
          <div class="table-actions-stack milestone-actions-stack">
            <p-button icon="pi pi-arrow-up" (onClick)="moveTaskUp(task)" [disabled]="tasks.indexOf(task) === 0"
              [text]="true" severity="secondary" size="small" pTooltip="Move up" tooltipPosition="top" />
            <p-button icon="pi pi-arrow-down" (onClick)="moveTaskDown(task)" [disabled]="tasks.indexOf(task) === tasks.length - 1"
              [text]="true" severity="secondary" size="small" pTooltip="Move down" tooltipPosition="top" />
            <p-button icon="pi pi-pencil" (onClick)="showEditTaskDialog(task)" [text]="true" severity="info" size="small"
              pTooltip="Edit" tooltipPosition="top" />
            <p-button icon="pi pi-trash" (onClick)="deleteTask(task)" [text]="true" severity="danger" size="small"
              pTooltip="Delete" tooltipPosition="top" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="9" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No milestone tasks found</p>
            <p class="empty-description">Click "Add" to create a new milestone task</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Task Dialog -->
<p-dialog
  [visible]="displayTaskDialog"
  (visibleChange)="displayTaskDialog = $event"
  [header]="isEditTaskMode ? 'Edit Milestone Task' : 'Add Milestone Task'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true">
  <div class="form-dialog-form form-dialog-compact" *ngIf="selectedTask">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field">
          <label for="taskNumber">Task Number</label>
          <input pInputText id="taskNumber" [(ngModel)]="selectedTask.taskNumber" placeholder="Enter task number" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['task'] && !selectedTask.task.trim()">
          <label for="task">Task <span class="required-star">*</span></label>
          <input pInputText id="task" [(ngModel)]="selectedTask.task" placeholder="Enter task name" required (blur)="fieldTouched['task'] = true" />
          <small class="field-error" *ngIf="fieldTouched['task'] && !selectedTask.task.trim()">Task name is required</small>
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="deliverable">Deliverable</label>
          <input pInputText id="deliverable" [(ngModel)]="selectedTask.deliverable" placeholder="Enter deliverable" />
        </div>
        <div class="field">
          <label for="status">Status <span class="required-star">*</span></label>
          <p-select id="status" [(ngModel)]="selectedTask.status" [options]="taskStatusOptions"
            optionLabel="label" optionValue="value" placeholder="Select status"
            panelStyleClass="filter-dropdown-panel" appendTo="body"
            [ngClass]="'status-' + getTaskStatusSeverity(selectedTask.status || '')">
            <ng-template let-option pTemplate="item">
              <div class="dropdown-item-content">
                <span class="status-badge" [ngClass]="'status-' + getTaskStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              <div class="dropdown-selected-content">
                <span class="status-badge" [ngClass]="'status-' + getTaskStatusSeverity(option.value)"></span>
                <span class="dropdown-text">{{ option.label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="startDate">Start Date <span class="required-star">*</span></label>
          <p-datepicker id="startDate" [(ngModel)]="taskStartDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select start date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
        <div class="field">
          <label for="targetDate">Target Date</label>
          <p-datepicker id="targetDate" [(ngModel)]="taskTargetDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select target date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
      </div>
      <div class="form-row two-columns">
        <div class="field">
          <label for="actualDate">Actual Date</label>
          <p-datepicker id="actualDate" [(ngModel)]="taskActualDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select actual date" [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
        <div class="field">
          <label for="comments">Comments</label>
          <textarea pInputText id="comments" [(ngModel)]="selectedTask.comments" rows="3" placeholder="Enter comments..." class="p-inputtext"></textarea>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetTaskForm()" [text]="true" severity="secondary" styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="displayTaskDialog = false" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveTask()" severity="primary" [disabled]="!selectedTask || !selectedTask.task.trim()" />
    </div>
  </ng-template>
</p-dialog>

